import React from "react";
import { COLORS } from "../../constants/colors";
import { LoadingIcon } from "../../constants/cssElements";
import './Loading.css';

const Loading = () => {
    return (
        <>
            <div className="LoadingPage_loading">
            </div>
            <div className='LoadingPage_loading-icon'>
                <LoadingIcon color={COLORS.blue_active} size={'5vh'} />
            </div>
        </>
    )
}

export default Loading;